<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YUt6gB/tc-custom/9781426883293.jpg?1740828628801" alt="This image is the cover for the book At Her Boss's Bidding"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">At Her Boss's Bidding
      </h1>
      <p class="bookDescription body article font2">
        <p>At her boss's command…but not under his control!<br/><br/>Justin McCarthy is a magnet for every man hunter in Sydney…they picture themselves spending his millions and cuddling up to him at night!<br/><br/>Rachel is Justin's idea of the perfect assistant. That is, until he pays for a complete makeover…one that unlocks the beauty within! Where once he was happy to have Rachel safely behind her desk, now Justin wants her across his…wild and willing. But then fantasy becomes reality, and Justin hasn't counted on love becoming part of his agenda!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Miranda Lee
      </h2>
      
      <p class="authorDescription body article">After leaving her convent school, Miranda Lee briefly studied the cello before moving to Sydney, where she embraced the emerging world of computers. Her career as a programmer ended after she married, had three daughters and bought a small acreage in a semi-rural community. She yearned to find a creative career from which she could earn money. When her sister suggested writing romances, it seemed like a good idea. She could do it at home, and it might even be fun! She never looked back.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a4767238